import axios from 'axios';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';

function EditarOfertas({act, toggle, alldet, todcanchas}) {
    axios.defaults.withCredentials = true;
    const [action, setAction] = useState( );
    const [aldet, setAldet] = useState({ });
    const [radiosbuttons, setRadios] = useState({todia_juego: false, todia_res: false });
    const [OfCanchas, setOfCanchas] = useState({ });
    const [inputs, setInputs] = useState({ });
    const [canfut5, setCanfut5] = useState([]);
    const [canfut7, setCanfut7] = useState([]);
    const [canfut11, setCanfut11] = useState([]);
    const [allcan, setallcan] = useState();
    const [inputsjue, setInputsjue] = useState({ });
    const [inputsres, setInputsres] = useState({ });
    const [canactivas, setCanActivas] = useState({ });
    axios.widthCredentials 

// useEffect(() => {
//     setAction(act);
//     setAldet(alldet.aenviar);
//     setCanActivas(alldet.activas);
//     setallcan(todcanchas);
//     setCanfut5(todcanchas.fut5);
//     setCanfut7(todcanchas.fut7);
//     setCanfut11(todcanchas.fut11);
// }, [act]);
// useEffect(() => {
//     if (!aldet || Object.keys(aldet).length === 0) {
//         return;
//     }
//     if (Object.values(aldet).length > 0) {
//         for (const [key,detalles] of Object.entries(aldet)){
//             // console.log(key,detalles);
//             setInputs((prev) => ({...prev, [key]: detalles}));
//             if (key === 'tipo') {
//                 setRadios((prev) => ({...prev, ['tipo']: detalles}));
//             }
//             if (key === 'tipoDeposito') {
//                 setRadios((prev) => ({...prev, ['deposito']: detalles}));
//             }
//             if (key === 'res_horainicio' && detalles === null){
//                 setRadios((prev) => ({...prev, ['todia_res']: true}));
//             }
//             if (key === 'jue_horainicio' && detalles === null){
//                 setRadios((prev) => ({...prev, ['todia_juego']: true}));
//             }
//         }
//     }
//     if (Object.values(canactivas).length > 0) {
//         for (const [key,detalles] of Object.entries(canactivas)){
//             setOfCanchas((prev) => ({
//             ...prev,
//             [Number(detalles.id)]: true
//         }));
//         }
//     }

// },[aldet]);

useEffect(() => {
    // 1. Update all primary states first
    setAction(act);
    setAldet(alldet.aenviar);
    setCanActivas(alldet.activas);
    setallcan(todcanchas);
    setCanfut5(todcanchas.fut5);
    setCanfut7(todcanchas.fut7);
    setCanfut11(todcanchas.fut11);

    // 2. Only process inputs AFTER aldet is guaranteed to be updated
    if (alldet.aenviar && Object.keys(alldet.aenviar).length > 0) {
        const newInputs = {};
        const newRadios = { todia_juego: false, todia_res: false };

        for (const [key, detalles] of Object.entries(alldet.aenviar)) {
            newInputs[key] = detalles; // Batch input updates

            if (key === 'tipo') newRadios.tipo = detalles;
            if (key === 'tipoDeposito') newRadios.deposito = detalles;
            if (key === 'res_horainicio' && detalles === null) newRadios.todia_res = true;
            if (key === 'jue_horainicio' && detalles === null) newRadios.todia_juego = true;
        }

        // Update inputs and radios in one go
        setInputs(newInputs);
        setRadios(newRadios);
    }

    // 3. Handle checkboxes
    if (alldet.activas && Object.keys(alldet.activas).length > 0) {
        const newCheckboxes = {};
        for (const [key, detalles] of Object.entries(alldet.activas)) {
            newCheckboxes[Number(detalles.id)] = true;
        }
        setOfCanchas(newCheckboxes);
    }
}, [act, alldet, todcanchas]); 

const cerrar = () => {
    toggle();
    setAction('');
    setAldet({ });
    setCanActivas({ });
    setallcan();
    setCanfut5();
    setCanfut7();
    setCanfut11();
    setInputs({ });
    setRadios({todia_juego: false, todia_res: false });
    setOfCanchas();
}

const actualizar = () => {
    const camposValidos = [
        inputs.nombre,
        inputs.numero,
        inputs.deposito,
        inputs.normas,
        inputs.res_fechainicio,
        inputs.res_fechafin,
        inputs.res_horainicio,
        inputs.res_horafin,
        inputs.jue_fechainicio,
        inputs.jue_fechafin,
        inputs.jue_horainicio,
        inputs.jue_horafin
    ].every(campo => campo === null || (campo !== undefined && campo.toString().trim() !== ''));
    const canchasSeleccionadas = Object.values(OfCanchas).some(v => v);
    
    if (!camposValidos || !canchasSeleccionadas) {
        toast.error('Completa todos los campos y selecciona al menos una cancha');
        return;
    }

    axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/updoferta`, [{chks: radiosbuttons, canch: OfCanchas, inputs}])
    .then((res) => {        
        if (res.data.success === true) {
            console.log(radiosbuttons, OfCanchas, inputs)
            cerrar();
            toast.success('Actualizado!')
        }
    })
    .catch((error)=>{
        console.error(error);
        
    })
}

const eliminar = () => {
    axios.post(`${process.env.REACT_APP_HTTPS}/api/ofertas/eliminarFecha`, [{alldet}])
    .then((res) => {        
        if (res.data.success === true) {
            cerrar();
            toast.success('Eliminada')   
        }
    })
    .catch((error)=>{
        console.error(error);
        window.alert('Error en eliminar')
    })
}


const handleRadioChange = (e) => {
    setRadios((prev) => ({
            ...prev,
            ['tipo']: e.target.value
        }));
  };
  const handleRadioChange2 = (e) => {
    setRadios((prev) => ({
            ...prev,
            ['deposito']: e.target.value
        }));
  };
  const handleCanchas = (e) => {
    setOfCanchas((prev) => ({
            ...prev,
            [e.target.id]: e.target.checked 
        }));
  };
  const capturarinput3 = (e) =>{
        setInputs((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }
    const capturarinput = (e) =>{
        setInputsres((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }

    const capturarinput2 = (e) =>{
        setInputsjue((prev) => ({
            ...prev,
            [e.target.id]: e.target.value
        }));
    }
    const radiohandle = (e) => {
    const { id, checked } = e.target;
    setRadios((prev) => ({
        ...prev,
        [id]: checked,
    }));

    if (id === 'todia_res') {
        setInputs((prev) => ({
            ...prev,
            res_horainicio: checked ? null : '',
            res_horafin: checked ? null : '',
        }));
    }
    if (id === 'todia_juego') {
        setInputs((prev) => ({
            ...prev,
            jue_horainicio: checked ? null : '',
            jue_horafin: checked ? null : '',
        }));
    }
};

const formatdate = (date) => {
    if (date) {
        const correct = new Date(date).toISOString().split('T')[0];
        return (correct) 
    }
}


  return (<>
    {action ==='editar' ? (<>
     <div className='popup_oferta'>
        <div className='input_ofb'>
            <div className='datos_oferta'><div className='inputsOfertas'>
                <label><b>Nombre de la oferta: </b><input type='text' className='nombre_oferta' onChange={capturarinput3} id='nombre' value={inputs.nombre}/></label><br/>
                <label><b>Tipo de oferta:</b></label>
                <form className='Of_F_radio'>
                    <label><input type='radio' onChange={handleRadioChange} value='porcentaje' checked={radiosbuttons.tipo === 'porcentaje'}/> Descuento general </label>
                    <label><input type='radio' onChange={handleRadioChange} value='fijo' checked={radiosbuttons.tipo === 'fijo'}/> Precio fijo </label>
                </form>
                <label><b>{radiosbuttons.tipo === 'fijo' ? (<>Precio: </>): 
                radiosbuttons.tipo === 'porcentaje' ? (<>Porcentaje: </>) : (<>Precio: </>)} </b><input type='number' className='numero' onChange={capturarinput3} id='numero' value={inputs.numero}
                disabled={radiosbuttons.tipo ? false : true}/></label><br/>
                <label><b>Depósito: </b>
                    <form className='Of_f_deposito'>
                        <label><input type='radio' onChange={handleRadioChange2} value='mismo' checked={radiosbuttons.deposito === 'mismo'}/> Mantener </label>
                        <label><input type='radio' onChange={handleRadioChange2} value='nuevo' checked={radiosbuttons.deposito === 'nuevo'}/> Nuevo </label>
                        <label><input type='radio' onChange={handleRadioChange2} value='porcentaje' checked={radiosbuttons.deposito === 'porcentaje'}/> % del total </label>
                    </form>
                    <input type='number' className='deposito_oferta' onChange={capturarinput3} id='deposito' value={inputs.deposito}
                    disabled={radiosbuttons.deposito ? (radiosbuttons.deposito === 'mismo' ? true : false) : true}/>
                </label><br/>
                <label><b>Normas: </b><textarea type='text' className='normas_oferta' onChange={capturarinput3} id='normas' value={inputs.normas}/></label>
                </div>
                <div className='oferta_selcan'>
                    <div style={{width: '100%', textAlign: 'center'}}><br/>
                        <h3>Selecione las canchas a las que aplicara la oferta</h3>
                        <p>Tome en cuenta que si se selecciona <b>Precio fijo</b> el precio colocado aplicara de igual manera para todas las canchas seleccionadas.</p>
                    </div>
                    {canfut5.length > 0 ? (<>
                        <div className='chk2_f5'>
                            <h4>Canchas de Fut 5</h4>
                            {canfut5?.map((can,i)=>(
                            <label key={i}> {can.nombre}
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>):null}
                    {canfut7.length > 0 ? (<>
                        <div className='chk2_f7'>
                            <h4>Canchas de Fut 7</h4>
                            {canfut7?.map((can,i)=>(
                            <label key={i}> {can.nombre}
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>):null}
                    {canfut11.length > 0 ? (<>
                        <div className='chk2_f11'>
                            <h4>Canchas de Fut 11</h4>
                            {canfut11?.map((can,i)=>(
                            <label key={i}> {can.nombre}
                                <input key={i} input type='checkbox' id={can.id} checked={OfCanchas[can.id]} onChange={handleCanchas}/>
                            </label>
                            ))}
                        </div>
                    </>): null }
                </div>
            </div>
            <div><br/>
                <h3>Realizacion de la reserva</h3>
                <label>Fecha Inicio: <input type='date' className='fechini' onChange={capturarinput3} id='res_fechainicio' value={formatdate(inputs.res_fechainicio)}/></label>
                <label>Fecha Finalizacion: <input type='date' className='fechfin' onChange={capturarinput3} id='res_fechafin' value={formatdate(inputs.res_fechafin)}/></label>
                <label>Hora Inicio: <input type='time' className='horaini' onChange={capturarinput3} id='res_horainicio' value={inputs.res_horainicio} disabled={radiosbuttons.todia_res}/></label>
                <label>Hora Finalizacion: <input type='time' className='horafin' onChange={capturarinput3} id='res_horafin' value={inputs.res_horafin} disabled={radiosbuttons.todia_res}/></label>
                <label>Todo el dia <input type='checkbox' onChange={radiohandle} checked={radiosbuttons.todia_res} id='todia_res'/></label>
                <br/>
            </div>
            <div>
                <h3>Tiempo de juego</h3>
                <label>Fecha Inicio: <input type='date' className='fechini' onChange={capturarinput3} id='jue_fechainicio' value={formatdate(inputs.jue_fechainicio)}/></label>
                <label>Fecha Finalizacion: <input type='date' className='fechfin' onChange={capturarinput3} id='jue_fechafin' value={formatdate(inputs.jue_fechafin)}/></label>
                <label>Hora Inicio: <input type='time' className='horaini' onChange={capturarinput3} id='jue_horainicio' value={inputs.jue_horainicio} disabled={radiosbuttons.todia_juego}/></label>
                <label>Hora Finalizacion: <input type='time' className='horafin' onChange={capturarinput3} id='jue_horafin' value={inputs.jue_horafin} disabled={radiosbuttons.todia_juego}/></label>
                <label>Todo el dia <input type='checkbox' onChange={radiohandle} checked={radiosbuttons.todia_juego} id='todia_juego'/></label>
                <br/>
            </div>
            <button onClick={actualizar} className='crear_of'>Guardar</button>
            <button onClick={cerrar} className='crear_of'>Cerrar</button>
        </div>
    </div>
    </>): action === 'eliminar' ? (<>
    
     <div className='popup_oferta'>
        <div className='input_ofb'>
            <div style={{width: '100%', display:"flex", justifyContent:"space-between"}}>
                <button className='crear_of' onClick={eliminar}>Eliminar</button>
                <button className='crear_of' onClick={cerrar}>Cerrar</button>
            </div>
        </div>
    </div>
    </>) : null}
    </>
  )
}

export default EditarOfertas